// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignIn from "views/Pages/SignIn";
import SignUp from "views/Pages/SignUp";
import PrivateRoute from "routes/PrivateRoute";
import LayoutDashboard from "layouts/LayoutDashboard";
import { RecoilRoot, useRecoilValue, useResetRecoilState } from "recoil";
import { userState } from "states/recoil";
import LayoutSuperAdmin from "layouts/LayoutSuperAdmin";
import AppInitializer from "states/AppInitializer";
import LayoutAdministrator from "layouts/LayoutAdministrator";
import LayoutSekretariat from "layouts/LayoutSekretariat";
import LayoutPemda from "layouts/LayoutPemda";

const DashboardRouter = () => {
  const user = useRecoilValue(userState);
  const resetUser = useResetRecoilState(userState);
  let layout = null;

  useEffect(() => {
    const validLevels = [
      999,
      "anggota",
      "administrator",
      "sekretariat",
      "pemda",
    ];
    if (!validLevels.includes(user.level)) {
      // clear invalid session
      localStorage.removeItem("sessionToken");
      localStorage.removeItem("userInfo");
      resetUser();
    }
  }, [user.level, resetUser]);

  if (user.level === 999) {
    layout = <LayoutSuperAdmin />;
  } else if (user.level === "anggota") {
    layout = <LayoutDashboard />;
  } else if (user.level === "administrator") {
    layout = <LayoutAdministrator />;
  } else if (user.level === "sekretariat") {
    layout = <LayoutSekretariat />;
  } else if (user.level === "pemda") {
    layout = <LayoutPemda />;
  } else {
    layout = <SignIn />;
  }

  return layout;
};

function App() {
  return (
    <RecoilRoot>
      <AppInitializer>
        <Router>
          <Routes>
            <Route path="/" element={<PrivateRoute />}>
              <Route index element={<DashboardRouter />} />
            </Route>
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
          </Routes>
        </Router>
      </AppInitializer>
    </RecoilRoot>
  );
}

export default App;
